
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ThumbsUp } from 'lucide-react';

interface GameCompletionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  gamesRemaining: number;
  onCreateAccount: () => void;
  onClose: () => void;
}

const GameCompletionDialog = ({ 
  open, 
  onOpenChange, 
  gamesRemaining, 
  onCreateAccount, 
  onClose 
}: GameCompletionDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center">
            <ThumbsUp className="w-5 h-5 mr-2 text-green-500" /> 
            Great Job!
          </DialogTitle>
          <DialogDescription>
            That was great! You have {gamesRemaining} free games remaining.
            Want to save your progress and unlock all games?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 mt-4">
          <Button 
            variant="outline" 
            onClick={onClose}
          >
            Not Now
          </Button>
          <Button 
            onClick={onCreateAccount}
          >
            Create Free Account
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GameCompletionDialog;
